<template>
    <div>
        <MeetingCreate
            v-model="showCreate"
        ></MeetingCreate>
        <ActivityDetails
            :activity-type="detailActivityType"
            :activity-id="detailActivityId"
            @close="closeDetail"
        ></ActivityDetails>
        <MeetingChangeDate
            :activity-id="changeDateMeetingId"
            @close="closeChangeDate"
        ></MeetingChangeDate>
        <MeetingDecline
            :activity-id="declineMeetingId"
            @close="closeDecline"
        ></MeetingDecline>

        <AccountTabs
            v-model="currentTab"
            :tabs="tabsWithCount"
        />

        <div class="content">
            <Button
                outline
                v-if="currentTab === 'upcoming'"
                class="btn btn-create"
                @click="showCreate = true"
            >Добавить встречу</Button>
            <div
                class="empty"
                v-if="!items.length"
            >
                {{ emptyText }}
            </div>
            <ActivityList
                v-else
                :items="currentItems"
                @click="open"
            />
            <ShowMoreButton
                v-if="currentItems.length < items.length "
                @click="currentLimit = null"
            ></ShowMoreButton>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import Button from '../../../UI/Button';
import ActivityList from './activities/List';
import MeetingCreate from './activities/Create';
import ActivityDetails from './activities/Details';
import MeetingChangeDate from './activities/ChangeDate';
import MeetingDecline from './activities/Decline';
import ShowMoreButton from './UI/ShowMoreButton';
import AccountTabs from '../../../UI/AccountTabs';
import {ActivityStatus, ActivityType} from '../../../../stores/mentoring/activities';

const actions = [
    'loadActivities',
];

const defaultLimit = 6;

export default {
    name: 'Activities',
    components: {
        Button,
        ActivityList,
        MeetingCreate,
        ActivityDetails,
        MeetingChangeDate,
        MeetingDecline,
        ShowMoreButton,
        AccountTabs,
    },
    data: () => ({
        loading: true,
        currentTab: 'upcoming',
        currentLimit: 6,
        tabs: [
            { label: 'Предстоящие', key: 'upcoming', color: 'blue', empty: 'Нет предстоящих активностей' },
            { label: 'Прошедшие', key: 'past', color: 'red', empty: 'Нет выполненных активностей' },
            { label: 'Пропущенные', key: 'skipped', color: 'grey', empty: 'Нет пропущенных активностей' },
        ],
        showCreate: false,
        editTask: null,
        detailActivityId: null,
        detailActivityType: null,
        changeDateMeetingId: null,
        declineMeetingId: null,
    }),
    computed: {
        ...mapState('mentoring', [
            'role',
        ]),
        currentTabItem() {
            return this.tabs.find(v => v.key === this.currentTab);
        },
        tabsWithCount() {
            return this.tabs
                .map(v => ({
                    ...v,
                    count: this.$store.getters[`mentoring/activities/${v.key}Activities`].length,
                }));
        },
        items() {
            let name = `${this.currentTabItem.key}Activities`;
            return this.$store.getters[`mentoring/activities/${name}`];
        },
        currentItems() {
            return this.items.reduce((acc, v) => {
                if (this.currentLimit && acc.count >= this.currentLimit) return acc;
                acc.items.push(v);
                acc.count += this.getColsCount(v);
                return acc;
            }, {count: 0, items: []}).items;
        },
        emptyText() {
            return this.currentTabItem.empty;
        },
    },
    methods: {
        getColsCount(item) {
            return this.role === 'mentor'
                && item.type === ActivityType.meeting
                && item.status === ActivityStatus.confirmation
                ? 3
                : 1;
        },
        ...mapActions('mentoring/activities', actions),
        open({ index, event_type }) {
            if (event_type === 'details') {
                this.detailActivityId = this.items[index].id;
                this.detailActivityType = this.items[index].type;
            }
            if (event_type === 'change_date') {
                this.changeDateMeetingId = this.items[index].id;
            }
            if (event_type === 'decline') {
                this.declineMeetingId = this.items[index].id;
            }
        },
        closeDetail() {
            this.detailActivityId = null;
            this.detailActivityType = null;
        },
        closeChangeDate() {
            this.changeDateMeetingId = null;
        },
        closeDecline() {
            this.declineMeetingId = null;
        },
    },
    watch: {
        currentTab() {
            this.currentLimit = defaultLimit;
        },
    },
    mounted() {
        this.loading = true;
        this.loadActivities();
        this.loading = false;
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../styles/rem';

    .empty {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #98A0A9;
        font-size: rem(15);
        line-height: rem(22);
        font-weight: 600;
    }

    @include on-mobile {
        .empty {
            font-size: mrem(14);
            line-height: mrem(17);
            font-weight: 500;
            margin: 0;
        }
    }

    .btn-create {
        margin-bottom: rem(26);
        padding: 0 rem(24);
        @include on-mobile{
            width: 100%;
            margin-bottom: mrem(36);
        }
    }
</style>